import { useAuth } from "oidc-react";
import { useEffect, useState } from "react";
import { useHttp } from "../../../common/http/httpService";
import { loadTranslationResources } from "../../../common/i18n/i18n";

const TranslatedContent = ({ children }) => {

  const auth = useAuth();
  const http = useHttp();
  const [translationsReady, setTranslationsReady] = useState(false);

  useEffect(() => {
    const loadTranslations = async() => {
      const results = await http.get('/translatabletext');
      loadTranslationResources(results);
      setTranslationsReady(true);
    };

    if (!auth.isLoading && auth.userData) {
      loadTranslations();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoading, auth.userData])

  return (
    translationsReady && (
    <>
      {children}
    </>
    )
  );
}

export default TranslatedContent;